import React from "react";
import { DatePicker as DatePickerPD } from "@pd/pd-ui-kit";
import { differenceInDays } from "date-fns";
import { Control, Controller } from "react-hook-form";

import { FormValues } from "~/widgets/Filters/FilterSummary/schema/types";

import styles from "~/widgets/Filters/FilterSummary/FilterSummary.less";

export interface DatePickerIProps {
  control: Control<FormValues>;
  setFastItem: (prop: "day" | "week" | "month" | null) => void;
  watchAllFields: Pick<FormValues, "startDate" | "endDate">;
  name: string;
  placeholder: string;
  format: string;
}

const DatePicker = ({
  control,
  name,
  placeholder,
  setFastItem,
  watchAllFields,
  format,
}: DatePickerIProps) => {
  const getDisabledDate = (current: Date, info?: { type: string }) => {
    if (!current) return false;
    if (info && info.type !== "date") {
      return false;
    }

    if (name === "startDate") {
      if (!watchAllFields.endDate) return false;

      const currentNormalized = new Date(current);
      const endDateNormalized = new Date(watchAllFields.endDate);

      const isAfterEndDate = currentNormalized > endDateNormalized;

      const isTooEarly =
        differenceInDays(endDateNormalized, currentNormalized) > 31;

      return isAfterEndDate || isTooEarly;
    }

    if (name === "endDate") {
      if (!watchAllFields.startDate) return false;

      const currentNormalized = new Date(current);
      const startDateNormalized = new Date(watchAllFields.startDate);

      const isBeforeStartDate = currentNormalized < startDateNormalized;

      const isTooLate =
        differenceInDays(currentNormalized, startDateNormalized) > 31;

      return isBeforeStartDate || isTooLate;
    }

    return false;
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ onChange, value, onBlur }) => (
        <DatePickerPD
          placeholder={placeholder}
          format={format}
          value={value}
          onBlur={onBlur}
          onChange={(date: Date) => {
            onChange(date ? new Date(date) : date);
            setFastItem(null);
          }}
          disabledDate={getDisabledDate}
          className={styles.pickerSize}
        />
      )}
    />
  );
};
export default DatePicker;
